import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { AIDisclosureResultState } from '../../types';
import { AIDisclosureResultModel } from '../disclosure-result-model';

function createAIDisclosureResultState (): AIDisclosureResultState {
    return {
        title: '',
        settings: {
            inventionSubject: [],
            applicationField: [],
            techMeans: '',
            techEffect: '',
            other: '',
            recommendInventionSubject: [],
            recommendApplicationField: [],
        },
        hidden: [],
        disclosureResult: [],
    };
}

@injectable()
export class AIDisclosureResultModelImpl extends AbstractModel<AIDisclosureResultState> implements AIDisclosureResultModel {
    protected _modelData: AIDisclosureResultState = createAIDisclosureResultState();

    public dispose() {
        this.update(() => {
            return createAIDisclosureResultState();
        });
    }
}
